import { z } from "zod";
import { ButtonVariant } from "../ButtonVariant.js";
import { iconSchema } from "../zod/iconSchema.js";
import { nonEmptyString } from "../zod/nonEmptyString.js";
import { urlSchema } from "../zod/urlSchema.js";

export const buttonBlockSchema = z.object({
	text: nonEmptyString,
	url: urlSchema,
	icon: iconSchema.optional(),
	variant: z.nativeEnum(ButtonVariant),
});
